<!--전역스타일적용해당안됨-->
<template>
  <div class="secret-mic-controller">
    <div class="button-group column">
      <p>ua: {{ userAgent.ua }}</p>
      <hr />
      <p>브라우저: {{ userAgent.browserName }}</p>
      <p>브라우저 버전: {{ userAgent.browserVersion }}</p>
      <hr />
      <p>기기: {{ userAgent.deviceName || '-' }}</p>
      <p>기기 타입: {{ userAgent.deviceType || '-' }}</p>
      <hr />
      <p>
        현재 마이크 라벨:
        {{ microphoneStore.selectedMicrophone.label }}
      </p>
      <p>
        현재 마이크 게인:
        {{ microphoneStore.isMicOn ? currentMicGain.nodeGain : '-' }}
      </p>
      <hr />
      <div class="button-wrap">
        <div>
          기본게인:
          <input
            v-model="currentMicGain.initialGain"
            type="number"
            placeholder="기본게인"
          />
          게인배율:
          <input
            v-model="currentMicGain.magnificationGain"
            type="number"
            placeholder="게인배율"
          />
        </div>
        <button
          type="button"
          class="btn"
          :disabled="!microphoneStore.isMicOn"
          @click.prevent="controlMicGain"
        >
          적용
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

import { isEqual } from 'lodash';

import useUserAgent from '@/composables/shared/useDevice';
import { useMicrophoneStore } from '@/stores/microphone';

const userAgent = useUserAgent();

const microphoneStore = useMicrophoneStore();

const currentMicGain = ref({
  nodeGain: 15,
  initialGain: 15,
  magnificationGain: 1,
});

const controlMicGain = () => {
  const { initialGain = 15, magnificationGain = 1 } = currentMicGain.value;
  currentMicGain.value.nodeGain = microphoneStore.controlMicGain({
    initialGain,
    magnificationGain,
  });
};

const initMicGain = () => {
  currentMicGain.value.initialGain =
    microphoneStore.selectedMicrophone.initialGain;
  currentMicGain.value.magnificationGain =
    microphoneStore.selectedMicrophone.magnificationGain;
};

watch(
  () => microphoneStore.selectedMicrophone,
  (val, oldValue) => {
    if (!isEqual(val, oldValue)) {
      initMicGain();
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.secret-mic-controller {
  position: fixed;
  width: 300px;
  bottom: 10%;
  left: 10px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  font-family: sans-serif;
  background-color: var(--surface-default);
  padding: 1rem;
  box-sizing: border-box;
  border: 1px solid gray;
}

.button-group {
  display: flex;
  gap: 8px;
}

.button-group.column {
  flex-direction: column;
}

.button-wrap {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  width: 15rem;
}

.button-group.row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
</style>
